import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspCreativesMgmt from './components/DspCreativesMgmt';

export default function DspCreativesPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon DSP Creatives</h3>
        </Col>
      </Row>
      <Row>
        <DspCreativesMgmt />
      </Row>
    </Container>
  );
}
